export const roles = {
  undefined: { id: 0, label: '' },
  admin: { id: 1, label: 'ELEMENT.ROLE.ADMIN' },
  manager: { id: 2, label: 'ELEMENT.ROLE.MANAGER' },
  mechanic: { id: 3, label: 'ELEMENT.ROLE.MECHANIC' },
  consultant: { id: 4, label: 'ELEMENT.ROLE.CONSULTANT' },
}
